var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4C5EC723-9150-477B-A222-76EFFBFC38CB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xEDcones",
    transform: "translate(-114.000000, -43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Time/calendar-1",
    transform: "translate(114.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0.833333295 L15,2.49999997 L17.5,2.49999997 C18.42,2.49999997 19.1666667,3.24583331 19.1666667,4.16666664 L19.1666667,4.16666664 L19.1666667,16.6666667 C19.1666667,17.5866667 18.42,18.3333333 17.5,18.3333333 L17.5,18.3333333 L2.49999997,18.3333333 C1.57999996,18.3333333 0.833333295,17.5866667 0.833333295,16.6666667 L0.833333295,16.6666667 L0.833333295,4.16666664 C0.833333295,3.24583331 1.57999996,2.49999997 2.49999997,2.49999997 L2.49999997,2.49999997 L4.16666664,2.49999997 L4.16666664,4.16666664 L2.49999997,4.16666664 L2.49999997,16.6666667 L17.5,16.6666667 L17.5,4.16666664 L15,4.16666664 L15,5.8333333 L13.3333333,5.8333333 L13.3333333,0.833333295 L15,0.833333295 Z M7.49999999,11.6666667 L7.49999999,15 L4.16666664,15 L4.16666664,11.6666667 L7.49999999,11.6666667 Z M11.6666667,11.6666667 L11.6666667,15 L8.33333333,15 L8.33333333,11.6666667 L11.6666667,11.6666667 Z M7.49999999,7.49999999 L7.49999999,10.8333333 L4.16666664,10.8333333 L4.16666664,7.49999999 L7.49999999,7.49999999 Z M11.6666667,7.49999999 L11.6666667,10.8333333 L8.33333333,10.8333333 L8.33333333,7.49999999 L11.6666667,7.49999999 Z M15.8333334,7.49999999 L15.8333334,10.8333333 L12.5,10.8333333 L12.5,7.49999999 L15.8333334,7.49999999 Z M6.66666665,0.833333295 L6.66666665,2.49999997 L12.5,2.49999997 L12.5,4.16666664 L6.66666665,4.16666664 L6.66666665,5.8333333 L4.99999998,5.8333333 L4.99999998,0.833333295 L6.66666665,0.833333295 Z",
    id: "\\uD83C\\uDFA8-Cor",
    fill: "#465EFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendario);
export default __webpack_public_path__ + "static/media/iconCalendario.16fdb6b0a04f102d925c9907ef9016ca.svg";
export { ForwardRef as ReactComponent };